import { Component, ElementRef, OnInit } from '@angular/core';
import { DataAnalyticsService } from '../../services/data-analytics.service';

@Component({
  selector: 'app-error',
  standalone: true,
  imports: [],
  templateUrl: './error.component.html',
  styleUrl: './error.component.css'
})
export class ErrorComponent implements OnInit {

  constructor(private element: ElementRef, private dataTag: DataAnalyticsService) {}

  ngOnInit(): void {
    this.dataTag.getAnalyticsTagging('technical-error')
  }
  
  ngAfterViewInit() {
    window['oneX']?.addElement(this.element.nativeElement);
  }

  ngOnDestroy() {
    window['oneX']?.removeElement(this.element.nativeElement);
  }
}
